import * as React from "react";
const SvgFiRrUserTag = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-tag_svg__a)">
      <path
        fill="#062147"
        d="m23.169 16.111-3.698-3.712a3 3 0 0 0-2.518-.856l-3.073.405a2.38 2.38 0 0 0-2.05 2.16l-.238 2.979a3 3 0 0 0 .865 2.355l3.708 3.723a2.82 2.82 0 0 0 1.998.825h.012a2.8 2.8 0 0 0 2.003-.842l3.005-3.044a2.837 2.837 0 0 0-.014-3.993M21.76 18.7l-3.005 3.043a.83.83 0 0 1-.588.248h-.003a.83.83 0 0 1-.584-.24l-3.705-3.72a1 1 0 0 1-.288-.785l.238-2.979a.37.37 0 0 1 .319-.336s3.158-.414 3.201-.414c.264 0 .522.106.71.295l3.7 3.714a.833.833 0 0 1 .005 1.174M18 16.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 18 16.5M8 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6M8 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m2 13a1 1 0 0 1-1 1c-3.86 0-7 3.141-7 7a1 1 0 1 1-2 0c0-4.963 4.038-9 9-9a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-tag_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserTag;
